import { useEffect } from 'react';

import { getApprovedBooking, setPaymentLoad } from '@pharmaplan/common';

import { useAppSelector } from '../useAppSelector';

import useCheckBookingUtils from './useCheckBookingUtils';
import { useAppDispatch } from '../useAppDispatch';

const useCheckBookingStatus = (bookingId: string) => {
  const dispatch = useAppDispatch();
  const approvedBooking = useAppSelector(getApprovedBooking);
  const { bookingCompleted, paymentProcessed, secret } = approvedBooking ?? {};

  const {
    keepCheckingBooking,
    confirm3dsPayment,
    checkStatus,
    StatusToCheck,
    handleSuccessfulBooking,
  } = useCheckBookingUtils(bookingId, secret);

  const handleBookingStatus = () => {
    if (bookingCompleted) {
      handleSuccessfulBooking();
    } else if (paymentProcessed && !bookingCompleted) {
      checkStatus.current = StatusToCheck.bookingPending;
      dispatch(setPaymentLoad(true));
      keepCheckingBooking();
    } else if (!paymentProcessed && !bookingCompleted && secret) {
      dispatch(setPaymentLoad(true));
      checkStatus.current = StatusToCheck.paymentHeld;
      confirm3dsPayment();
    }
  };

  useEffect(() => {
    if (bookingId) {
      handleBookingStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approvedBooking]);

  return { showLoader: checkStatus.current !== null };
};

export default useCheckBookingStatus;
